/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useState, Fragment } from 'react'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import { Select } from 'antd'
import NavBar from '@views/Navbar'
//img
import clubPortalBg from '@assets/images/bg/club-portal/club-portal-bg.png'
import clubPortalTit from '@assets/images/bg/club-portal/club-portal-tit.png'
import clubPortalSpecificTit from '@assets/images/bg/club-portal/club-portal-specific-tit.png'
// import superiorClubBadgeIco from '@assets/images/icon/club_icon/superior-club-badge-ico.png'
import { ArrowIco, CircleDownIco } from '@shared/Icon/ArrowIcon'
// css
import { TitleWrap, DropdownWrap, PageBgStyle } from '@styles/base.style'
import { BackBtn } from '@styles/button.style'
import { useOnMount } from '@utils/reactExt'
import useRootStore from '@store/useRootStore'
import { CLUB_MEMBERSHIP_ID } from 'adv-protocol/src/GameCommon'
import { SimpleClubInfoItem } from '@store/clubStore'
import Chat from '@views/Popup/Chat'
import { ClubPortalWrap } from './index.style'
import ClubPortal from './ClubPortal'
import { appScrollTo, loadOrReload } from '@utils/utils'
import PopupUtils from '@utils/popup-utils'
import RankingPopupButton from '@views/Popup/RankingPopup/Button'

const CircleDown = (
  <span className="circle-down-ico dark">
    <CircleDownIco/>
  </span>
)

const CLUB_LIST_TYPE = {
  MEMBERSHIP: 0,
  FREE: 1,
}

const Club: React.FC = props => {
  const [clubListType, setClubListType] = useState(CLUB_LIST_TYPE.MEMBERSHIP)
  const {
    authStore, clubStore, matchupStore, routerStore,
    chattingStore, componentStore, globalStore, logStore,
  } = useRootStore()
  const { signedin } = authStore
  const { simpleClubs = [] } = clubStore
  const { isChatEnabled } = chattingStore

  const onClickMatchup = (id: string) => {
    if (isMobile) {
      appScrollTo(1)
      loadOrReload(`/matchup/cross/${id}`)
      matchupStore.resetClubInfo()
    } else {
      matchupStore.changeClubId(id)
      globalStore.setVisibleMatchupBottomBannerPopup(true)
    }
  }

  const onClickShowDetail = (club: SimpleClubInfoItem) => {
    if (club !== null) {
      PopupUtils.showClubInfoPopup({
        club,
        onCloseClubDetail,
        onClickMatchup
      })
    }
    componentStore.setExtraClubId(club.id)
    clubStore.fetchUnReadClubMessageCount(club.id)
  }

  const onCloseClubDetail = () => {
    globalStore.closeGeneralPopup()
  }

  const onChangeClubListType = (type) => {
    setClubListType(type)
  }

  useOnMount(() => {
    if (!authStore.isSignedIn) {
      loadOrReload('/')
    }
    clubStore.fetchSimpleClubs({})

    if (isMobile) {
      setTimeout(() => {
        appScrollTo(1)
      }, 0)
    }
  })

  const clubList = []
  for (const club of simpleClubs) {
    if ((clubListType === CLUB_LIST_TYPE.MEMBERSHIP && club.grade === CLUB_MEMBERSHIP_ID.FREE)
      || (clubListType === CLUB_LIST_TYPE.FREE && club.grade !== CLUB_MEMBERSHIP_ID.FREE)) {
      continue
    }

    const clubPortalKey = `Club:ClubPortal:${club.id}`
    clubList.push(
      <ClubPortal
        key={clubPortalKey}
        currentClubId={matchupStore?.club?.id}
        signedin={signedin}
        club={club}
        onClickMatchup={onClickMatchup}
        onClickShowDetail={onClickShowDetail}
      />,
    )
  }

  const { Option } = Select
  return (
    <Fragment>
      <TitleWrap className="title-wrap no-bg">
        {isMobile && (
          <BackBtn onClick={() => {
            logStore.writeButtonLog({ pageId: 'd040', buttonId: '001' }).catch(console.error)
            routerStore.goBack()
          }}>
            <ArrowIco/>
          </BackBtn>
        )}
      </TitleWrap>

      <ClubPortalWrap className="club-portal-wrap">
        <div css={PageBgStyle} className="club-portal-bg">
          <img src={clubPortalBg} alt="축구 경기장" className="club-portal-bg"/>
        </div>

        <div className="club-portal-top">
          <div className="club-portal-tit">

            {!authStore.isSpecificClubMember ? <img src={clubPortalTit} alt="여러 클럽에서 다양한 배당과 이벤트를 경험하세요" className="club-portal-tit--img"/> :
              <img src={clubPortalSpecificTit} alt="여러 클럽에서 스포츠 예측의 재미를 경험하세요" className="club-portal-tit--img specific-tit-img"/>}

          </div>
          {!authStore.isSpecificClubMember ?
            <div className="club-division">

              {/* *********** 멤버쉽 클럽일 경우 *********** */}
              {/* 기획 변경으로 주석처리 [이슈링크](https://task.zempublic.co.kr/view.php?id=9798) */}
              {/*{clubListType === CLUB_LIST_TYPE.MEMBERSHIP && <span className="superior-club-badge-info">*/}
              {/*   <img src={superiorClubBadgeIco} alt="우수클럽배지"/>*/}
              {/*   <span className='superior-club-badge-info--txt'>:우수클럽</span>*/}
              {/*</span>}*/}

              {/* *********** 프리 클럽일 경우 *********** */}
              {clubListType === CLUB_LIST_TYPE.FREE &&
              <span className="free-club-info">&#8251; 프리클럽은 배당, 경기 수에 제한이 있을 수 있습니다.</span>}

              <DropdownWrap id="club-select-parent" className="club-select-drop-down">
                <Select defaultValue={clubListType} className="club-select" onChange={onChangeClubListType} getPopupContainer={() => document.getElementById('club-select-parent')}>

                  <Option value={CLUB_LIST_TYPE.MEMBERSHIP}>
                    <span className="option-txt">클럽</span>
                  </Option>
                  <Option value={CLUB_LIST_TYPE.FREE}>
                    <span className="option-txt">프리 클럽</span>
                  </Option>
                </Select>
                {CircleDown}
              </DropdownWrap>
            </div>
            : ''}
        </div>

        <div className="club-portal-list">
          {clubList}
        </div>

      </ClubPortalWrap>

      {isChatEnabled && !authStore.isSpecificClubMember && isMobile && <Chat key="Club:Chat"/>}

      {/*TODO: 랭킹 현황을 볼 수 있는 팝업*/}
      <RankingPopupButton/>
      {isMobile && <NavBar key="Club:NavBar"/>}
    </Fragment>
  )
}

export default observer(Club)
